import { defineComponent as _defineComponent } from 'vue'
import { ref, inject } from "vue";
import router from "@/router/index";
import { useUserStore } from "@/stores/userStore";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import PasswordInput from "@/components/shared/inputs/PasswordInput.vue";
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import {
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  ShowErrorModal,
  ShowLoadingImage,
} from "@/types";
import { useRoute } from "vue-router";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "MyInfoAuth",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showLoadingImage = inject(
  PROVIDE_KEY_SHOW_LOADING_IMAGE
) as ShowLoadingImage;
const removeLoadingImage = inject(
  PROVIDE_KEY_REMOVE_LOADING_IMAGE
) as RemoveLoadingImage;

const userStore = useUserStore();
const route = useRoute();
const nextPageName = route.query.nextPageName?.toString() ?? "";
const userId = ref("");
userId.value = userStore.loginId ?? "";

const password = ref("");

const authContainer = ref<HTMLElement>();

const requestAuth = async () => {
  showLoadingImage();
  const authResult = await userStore.checkPassword(password.value);
  removeLoadingImage();

  if (!authResult.isSuccess) {
    showErrorModal(
      "인증실패",
      "비밀번호가 일치하지 않습니다.",
      authResult.resultCode
    );
    return;
  }
  goToNextPage();
};

const goToNextPage = () => {
  router.replace({ name: nextPageName });
};

const __returned__ = { showErrorModal, showLoadingImage, removeLoadingImage, userStore, route, nextPageName, userId, password, authContainer, requestAuth, goToNextPage, Page, NavigationBar, PasswordInput, BaseButton, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})